import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EmailtemplateService} from '../../emailtemplate.service';
import {environment} from '../../../environments/environment';

declare let $;

@Component({
  selector: 'app-apigateway-manager',
  templateUrl: './apigateway-manager.component.html',
  styleUrls: ['./apigateway-manager.component.scss']
})

export class ApigatewayManagerComponent implements OnInit {

  @Input() gatewayPayload: any;
  // @Input() configurationsGatewayPayload: any;
  @Input() displayFlag = true;
  @Output() selectedGatewayOutput = new EventEmitter<{}>();
  @Output() change = new EventEmitter<{}>();

  partner = localStorage.getItem('partner');

  APIGateways: any;
  selectedAPIGateway: any;


  constructor(private emailTemplateInstance: EmailtemplateService) { }

  ngOnInit() {

    const that = this;

    $(document).ready(function () {
      for (let i = 0; i < that.gatewayPayload.length; i++) {
        for (let j = 0; j < that.APIGateways.length; j++) {
          if (that.gatewayPayload[i] === that.APIGateways[j]['value']) {
            const id = 'selectedGateway' + j;
            $('#' + id).css('border', '2px solid #ff672d');
          }
        }
      }

      // for (let i = 1; i < that.APIGateways.length; i++) {
      //   const id = 'selectedGateway' + i;
      //   $('#' + id).css('background-color', 'lightgrey');
      // }
    });

    const temp = this.partner.split('-');

    this.APIGateways = [
      {
        gateway: 'apiplatform',
        image: './assets/img/partnerOnboarding/api.png',
        description: 'Default',
        value: 'default',
        provider: 'apiplatform.io',
        gateway_configurations: [
          {
            "name": "key-auth",
            "isConfigured": false,
            "img": "/assets/img/key-auth.png",
            "description": "Configure KeyAuth service..",
            "enabled": true,
            "consumer": {},
            "tagline": "Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests.",
            "config": [
              {
                'displayName': 'Key Names',
                'parameter': 'key_names',
                'type': 'array_string',
                'value': 'apikey',
                'isRequired': true,
                'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\n' +
                    'Note: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
              },
              {
                'displayName': 'Key In Body',
                'parameter': 'key_in_body',
                'type': 'boolean',
                'value': false,
                'isRequired': false,
                'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
              },
              {
                'displayName': 'Hide Credentials',
                'parameter': 'hide_credentials',
                'type': 'boolean',
                'value': false,
                'isRequired': false,
                'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
              },
              {
                'displayName': 'Run On Preflight',
                'parameter': 'run_on_preflight',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
              },
              {
                'displayName': 'Key In Header',
                'parameter': 'key_in_header',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
              },
              {
                'displayName': 'Key In Query',
                'parameter': 'key_in_query',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
              },
            ],
            "itemName": "key-auth"
          },
          {
            "name": "cors",
            "isConfigured": false,
            "img": "assets/img/cors.png",
            "description": "Configure CORS service.",
            "enabled": true,
            "consumer": {},
            "tagline": "Allow developers to make requests from the browser. Easily add cross-origin resource sharing (CORS) to a Service and a Route by enabling this plugin",
            "config": [
              // {
              //   'parameter': 'consumerID',
              //   'type': 'string',
              //   'value': '',
              //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
              // },
              {
                'displayName': 'Origins',
                'parameter': 'origins',
                'type': 'array_string',
                'value': '*',
                'isRequired': false,
                'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
              },
              {
                'displayName': 'Headers',
                'parameter': 'headers',
                'type': 'array_string',
                'value': null,
                'isRequired': false,
                'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
              },
              {
                'displayName': 'Exposed Headers',
                'parameter': 'exposed_headers',
                'type': 'array_string',
                'value': null,
                'isRequired': false,
                'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
              },
              {
                'displayName': 'Methods',
                'parameter': 'methods',
                'type': 'array_string',
                'value': null,
                'isRequired': false,
                'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
              },
              {
                'displayName': 'Max Age',
                'parameter': 'max_age',
                'type': 'number',
                'value': 300,
                'isRequired': false,
                'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
              },
              {
                'displayName': 'Credentials',
                'parameter': 'credentials',
                'type': 'boolean',
                'value': false,
                'isRequired': true,
                'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
              },
              {
                'displayName': 'Preflight Continue',
                'parameter': 'preflight_continue',
                'type': 'boolean',
                'value': false,
                'isRequired': true,
                'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
              }
            ],
            "itemName": "cors"
          },
          {
            "name": "ip-restriction",
            "isConfigured": false,
            "img": "assets/img/ip-restriction.png",
            "description": "Configure IP Restriction service.",
            "tagline": "Restrict access to a Service or a Route by either allowing or denying IP addresses. Single IPs, multiple IPs or ranges in CIDR notation like 10.10.10.0/24 can be used. The plugin supports IPv4 and IPv6 addresses",
            "enabled": false,
            "consumer": {},
            "config": [
              // {
              //   'parameter': 'consumerID',
              //   'type': 'string',
              //   'value': '',
              //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
              // },
              {
                'displayName': 'Allow',
                'parameter': 'allow',
                'type': 'array_string',
                'value': '127.0.0.1',
                'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
              },
              {
                'displayName': 'Deny',
                'parameter': 'deny',
                'type': 'array_string',
                'value': null,
                'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
              }
            ],
            "itemName": "ip-restriction"
          },
          {
            "name": "rate-limiting",
            "isConfigured": false,
            "img": "/assets/img/rate-limiting.png",
            "description": "Configure Rate limiting service.",
            "enabled": true,
            "consumer": {},
            "tagline": "Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured",
            "config": [
              {
                'displayName': 'Second',
                'parameter': 'second',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per second'
              },
              {
                'displayName': 'Minute',
                'parameter': 'minute',
                'type': 'number',
                'value': 5,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per minute'
              },
              {
                'displayName': 'Hour',
                'parameter': 'hour',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per hour'
              },
              {
                'displayName': 'Day',
                'parameter': 'day',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per day'
              },
              {
                'displayName': 'Month',
                'parameter': 'month',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per month'
              },
              {
                'displayName': 'Year',
                'parameter': 'year',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per year'
              },
              {
                'displayName': 'Limit By',
                'parameter': 'limit_by',
                'type': 'string',
                'value': 'consumer',
                'isRequired': false,
                'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
              },
              {
                'displayName': 'Policy',
                'parameter': 'policy',
                'type': 'string',
                'value': 'local',
                'isRequired': false,
                'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
                    '\n' +
                    'In Konnect Cloud, the default policy is redis'
              },
              {
                'displayName': 'Fault Tolerant',
                'parameter': 'fault_tolerant',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
              },
              {
                'displayName': 'Hide Client Headers',
                'parameter': 'hide_client_headers',
                'type': 'boolean',
                'value': false,
                'isRequired': false,
                'description': 'Optionally hide informative response headers'
              },
              {
                'displayName': 'Redis Host',
                'parameter': 'redis_host',
                'type': 'string',
                'value': 'localhost',
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the address to the Redis server'
              },
              {
                'displayName': 'Redis Password',
                'parameter': 'redis_password',
                'type': 'string',
                'value': '',
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
              },
              {
                'displayName': 'Redis Port',
                'parameter': 'redis_port',
                'type': 'number',
                'value': 6379,
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
              },
              {
                'displayName': 'Redis Timeout',
                'parameter': 'redis_timeout',
                'type': 'number',
                'value': 2000,
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
              },
              {
                'displayName': 'Redis Database',
                'parameter': 'redis_database',
                'type': 'number',
                'value': 0,
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the Redis database to use'
              },
              // {
              //   'displayName': 'Header Name',
              //   'parameter': 'header_name',
              //   'type': 'string',
              //   'value': '',
              //     'isRequired': false,
              //     'description': 'Header name to be used if limit_by is set to header'
              // },
              // {
              //   'displayName': 'Path',
              //   'parameter': 'path',
              //   'type': 'string',
              //   'value': '',
              //   'isRequired': false,
              //   'description': 'Path to be used if limit_by is set to path'
              // },
            ],
            "itemName": "rate-limiting"
          },
          {
            'name': 'datadog',
            'isConfigured': false,
            'img': '/assets/img/datadog.png',
            'description': 'Configure Datadog service.',
            'tagline': 'Visualize API metrics on Datadog',
            "enabled": true,
            "consumer": {},
            'config': [

              {
                'displayName': 'Host',
                'parameter': 'host',
                'type': 'string',
                'value': '127.0.0.1',
                'isRequired': true,
                'description': 'The IP address or host name to send data to'
              },
              {
                'displayName': 'Port',
                'parameter': 'port',
                'type': 'number',
                'value': 8125,
                'isRequired': true,
                'description': 'The port to send data to on the upstream server'
              },
              {
                'displayName': 'Prefix',
                'parameter': 'prefix',
                'type': 'string',
                'value': 'apiplatform',
                'isRequired': true,
                'description': 'String to be attached as prefix to metric’s name'
              }
            ]
          },
          {
            'name': 'acl',
            'isConfigured': false,
            'img': '/assets/img/acl.png',
            'description': 'Configure ACL service.',
            'tagline': 'Restrict access to a Service or a Route by adding Consumers to allowed or denied lists using arbitrary ACL group names. This plugin requires an authentication plugin (such as Basic Authentication, Key Authentication, OAuth 2.0, and OpenID Connect) to have been already enabled on the Service or Route',
            "enabled": true,
            "consumer": {},
            'config': [
              // {
              //   'parameter': 'consumerID',
              //   'type': 'string',
              //   'value': '',
              //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
              // },
              {
                'displayName': 'Allow',
                'parameter': 'allow',
                'type': 'array_string',
                'value': temp[temp.length - 1],
                'description': 'Tip: Comma separated list of arbitrary group names that are allowed to consume the API. At least one between whitelist or blacklist must be specified.'
              },
              {
                'displayName': 'Deny',
                'parameter': 'deny',
                'type': 'array_string',
                'value': null,
                'description': 'Tip: Comma separated list of arbitrary group names that are not allowed to consume the API. At least one between whitelist or blacklist must be specified.'
              },
              {
                'displayName': 'Hide Groups Header',
                'parameter': 'hide_groups_header',
                'type': 'boolean',
                'value': false,
                'isRequired': true,
                'description': 'Flag that if enabled (true), prevents the X-Consumer-Groups header to be sent in the request to the Upstream service'
              }
            ]
          }
        ],
        name: 'default',
        type: 'kong',
        config: {
          protocol: 'https',
          host: environment.adminGatewayHost,
          port: environment.adminPort
        }
      },
      {
        gateway: 'Kong',
        image: './assets/img/kong.png',
        description: 'Kong',
        value: 'kong',
        provider: 'kong',
        gateway_configurations: [
          {
            "name": "key-auth",
            "isConfigured": false,
            "img": "/assets/img/key-auth.png",
            "description": "Configure KeyAuth service..",
            "enabled": true,
            "consumer": {},
            "tagline": "Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests.",
            "config": [
              {
                'displayName': 'Key Names',
                'parameter': 'key_names',
                'type': 'array_string',
                'value': 'apikey',
                'isRequired': true,
                'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\n' +
                    'Note: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
              },
              {
                'displayName': 'Key In Body',
                'parameter': 'key_in_body',
                'type': 'boolean',
                'value': false,
                'isRequired': false,
                'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
              },
              {
                'displayName': 'Hide Credentials',
                'parameter': 'hide_credentials',
                'type': 'boolean',
                'value': false,
                'isRequired': false,
                'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
              },
              {
                'displayName': 'Run On Preflight',
                'parameter': 'run_on_preflight',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
              },
              {
                'displayName': 'Key In Header',
                'parameter': 'key_in_header',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
              },
              {
                'displayName': 'Key In Query',
                'parameter': 'key_in_query',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
              },
            ],
            "itemName": "key-auth"
          },
          {
            "name": "cors",
            "isConfigured": false,
            "img": "assets/img/cors.png",
            "description": "Configure CORS service.",
            "tagline": "Allow developers to make requests from the browser. Easily add cross-origin resource sharing (CORS) to a Service and a Route by enabling this plugin",
            "enabled": true,
            "consumer": {},
            "config": [
              // {
              //   'parameter': 'consumerID',
              //   'type': 'string',
              //   'value': '',
              //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
              // },
              {
                'displayName': 'Origins',
                'parameter': 'origins',
                'type': 'array_string',
                'value': '*',
                'isRequired': false,
                'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
              },
              {
                'displayName': 'Headers',
                'parameter': 'headers',
                'type': 'array_string',
                'value': null,
                'isRequired': false,
                'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
              },
              {
                'displayName': 'Exposed Headers',
                'parameter': 'exposed_headers',
                'type': 'array_string',
                'value': null,
                'isRequired': false,
                'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
              },
              {
                'displayName': 'Methods',
                'parameter': 'methods',
                'type': 'array_string',
                'value': null,
                'isRequired': false,
                'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
              },
              {
                'displayName': 'Max Age',
                'parameter': 'max_age',
                'type': 'number',
                'value': 300,
                'isRequired': false,
                'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
              },
              {
                'displayName': 'Credentials',
                'parameter': 'credentials',
                'type': 'boolean',
                'value': false,
                'isRequired': true,
                'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
              },
              {
                'displayName': 'Preflight Continue',
                'parameter': 'preflight_continue',
                'type': 'boolean',
                'value': false,
                'isRequired': true,
                'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
              }
            ],
            "itemName": "cors"
          },
          {
            "name": "ip-restriction",
            "isConfigured": false,
            "img": "assets/img/ip-restriction.png",
            "description": "Configure IP Restriction service.",
            "tagline": "Restrict access to a Service or a Route by either allowing or denying IP addresses. Single IPs, multiple IPs or ranges in CIDR notation like 10.10.10.0/24 can be used. The plugin supports IPv4 and IPv6 addresses",
            "enabled": false,
            "consumer": {},
            "config": [
              // {
              //   'parameter': 'consumerID',
              //   'type': 'string',
              //   'value': '',
              //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
              // },
              {
                'displayName': 'Allow',
                'parameter': 'allow',
                'type': 'array_string',
                'value': '127.0.0.1',
                'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
              },
              {
                'displayName': 'Deny',
                'parameter': 'deny',
                'type': 'array_string',
                'value': null,
                'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
              }
            ],
            "itemName": "ip-restriction"
          },
          {
            "name": "rate-limiting",
            "isConfigured": false,
            "img": "/assets/img/rate-limiting.png",
            "description": "Configure Rate limiting service.",
            "enabled": true,
            "consumer": {},
            "tagline": "Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured",
            "config": [
              {
                'displayName': 'Second',
                'parameter': 'second',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per second'
              },
              {
                'displayName': 'Minute',
                'parameter': 'minute',
                'type': 'number',
                'value': 5,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per minute'
              },
              {
                'displayName': 'Hour',
                'parameter': 'hour',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per hour'
              },
              {
                'displayName': 'Day',
                'parameter': 'day',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per day'
              },
              {
                'displayName': 'Month',
                'parameter': 'month',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per month'
              },
              {
                'displayName': 'Year',
                'parameter': 'year',
                'type': 'number',
                'value': null,
                'isRequired': false,
                'description': 'The number of HTTP requests that can be made per year'
              },
              {
                'displayName': 'Limit By',
                'parameter': 'limit_by',
                'type': 'string',
                'value': 'consumer',
                'isRequired': false,
                'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
              },
              {
                'displayName': 'Policy',
                'parameter': 'policy',
                'type': 'string',
                'value': 'local',
                'isRequired': false,
                'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
                    '\n' +
                    'In Konnect Cloud, the default policy is redis'
              },
              {
                'displayName': 'Fault Tolerant',
                'parameter': 'fault_tolerant',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
              },
              {
                'displayName': 'Hide Client Headers',
                'parameter': 'hide_client_headers',
                'type': 'boolean',
                'value': false,
                'isRequired': false,
                'description': 'Optionally hide informative response headers'
              },
              {
                'displayName': 'Redis Host',
                'parameter': 'redis_host',
                'type': 'string',
                'value': 'localhost',
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the address to the Redis server'
              },
              {
                'displayName': 'Redis Password',
                'parameter': 'redis_password',
                'type': 'string',
                'value': '',
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
              },
              {
                'displayName': 'Redis Port',
                'parameter': 'redis_port',
                'type': 'number',
                'value': 6379,
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
              },
              {
                'displayName': 'Redis Timeout',
                'parameter': 'redis_timeout',
                'type': 'number',
                'value': 2000,
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
              },
              {
                'displayName': 'Redis Database',
                'parameter': 'redis_database',
                'type': 'number',
                'value': 0,
                'isRequired': false,
                'description': 'When using the redis policy, this property specifies the Redis database to use'
              },
              // {
              //   'displayName': 'Header Name',
              //   'parameter': 'header_name',
              //   'type': 'string',
              //   'value': '',
              //     'isRequired': false,
              //     'description': 'Header name to be used if limit_by is set to header'
              // },
              // {
              //   'displayName': 'Path',
              //   'parameter': 'path',
              //   'type': 'string',
              //   'value': '',
              //   'isRequired': false,
              //   'description': 'Path to be used if limit_by is set to path'
              // },
            ],
            "itemName": "rate-limiting"
          },
          {
            'name': 'datadog',
            'isConfigured': false,
            'img': '/assets/img/datadog.png',
            'description': 'Configure Datadog service.',
            'tagline': 'Visualize API metrics on Datadog',
            "enabled": true,
            "consumer": {},
            'config': [

              {
                'displayName': 'Host',
                'parameter': 'host',
                'type': 'string',
                'value': '127.0.0.1',
                'isRequired': true,
                'description': 'The IP address or host name to send data to'
              },
              {
                'displayName': 'Port',
                'parameter': 'port',
                'type': 'number',
                'value': 8125,
                'isRequired': true,
                'description': 'The port to send data to on the upstream server'
              },
              {
                'displayName': 'Prefix',
                'parameter': 'prefix',
                'type': 'string',
                'value': 'apiplatform',
                'isRequired': true,
                'description': 'String to be attached as prefix to metric’s name'
              }
            ]
          },
          {
            'name': 'acl',
            'isConfigured': false,
            'img': '/assets/img/acl.png',
            'description': 'Configure ACL service.',
            'tagline': 'Restrict access to a Service or a Route by adding Consumers to allowed or denied lists using arbitrary ACL group names. This plugin requires an authentication plugin (such as Basic Authentication, Key Authentication, OAuth 2.0, and OpenID Connect) to have been already enabled on the Service or Route',
            "enabled": true,
            "consumer": {},
            'config': [
              // {
              //   'parameter': 'consumerID',
              //   'type': 'string',
              //   'value': '',
              //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
              // },
              {
                'displayName': 'Allow',
                'parameter': 'allow',
                'type': 'array_string',
                'value': temp[temp.length - 1],
                'description': 'Tip: Comma separated list of arbitrary group names that are allowed to consume the API. At least one between whitelist or blacklist must be specified.'
              },
              {
                'displayName': 'Deny',
                'parameter': 'deny',
                'type': 'array_string',
                'value': null,
                'description': 'Tip: Comma separated list of arbitrary group names that are not allowed to consume the API. At least one between whitelist or blacklist must be specified.'
              },
              {
                'displayName': 'Hide Groups Header',
                'parameter': 'hide_groups_header',
                'type': 'boolean',
                'value': false,
                'isRequired': true,
                'description': 'Flag that if enabled (true), prevents the X-Consumer-Groups header to be sent in the request to the Upstream service'
              }
            ]
          }
        ],
        name: '',
        type: 'kong',
        config: {
          protocol: 'https',
          host: environment.adminGatewayHost,
          port: environment.adminPort
        }
      },
      {
        gateway: 'Google',
        image: './assets/img/partnerOnboarding/apigee.png',
        description: 'APIGEE',
        value: 'apigee',
        provider: 'google',
        type: 'apigee',
        gateway_configurations: [],
        name: '',
        config: {
          protocol: '',
          host: '',
        }
      },
      {
        gateway: 'Microsoft',
        image: './assets/img/partnerOnboarding/azure.png',
        description: 'Azure',
        value: 'azure',
        provider: 'microsoft',
        type: 'azure',
        gateway_configurations: [],
        name: '',
        config: {
          protocol: '',
          host: '',
        }
      },
      {
        gateway: 'Amazon',
        image: './assets/img/partnerOnboarding/awsGateway.png',
        description: 'AWS API Gateway',
        value: 'aws',
        type: 'aws',
        provider: 'amazon',
        gateway_configurations: [],
        name: '',
        config: {
          protocol: '',
          host: '',
        }
      }
    ];

    this.selectedAPIGateway = this.APIGateways[0];

    //To emit initial selected gateway while adding environment.
    this.selectedGatewayOutput.emit(this.selectedAPIGateway);
  }
  Update() {
    this.change.emit();
  }
  selectGateway(index) {
    if (this.APIGateways[index]['value'] === 'default' || this.displayFlag === false) {
      this.gatewayPayload[0] = this.APIGateways[index]['value'];
      this.selectedAPIGateway = this.APIGateways[index];
      // this.configurationsGatewayPayload[0].gateway_name = this.APIGateways[index]['value'];
      this.selectedGatewayOutput.emit(this.selectedAPIGateway);
      for (let i = 0; i < this.APIGateways.length; i++) {
        const id = 'selectedGateway' + i;
        if (index === i) {
          $('#' + id).css('border', '2px solid #ff672d');
        } else {
          $('#' + id).css('border', 'transparent');
        }
      }
    } else {
      alert('Thank you for choosing this service. Use of this service requires additional settings including configuration of payment methods. You can sign up now with default option and change your settings after successfully logging into Platform Console.');
      this.emailTemplateInstance.notifyPartnerOnboarding.to.value[0].gateway = this.APIGateways[index]['value'];
    }
  }
}
